export const eventsGlobal = {
  ERROR_WINDOW_TOGGLED: 'ERROR_WINDOW_TOGGLED',
  MESSAGE_CLICKED: 'MESSAGE_CLICKED',
  SELECT_PARAMETER: 'SELECT_PARAMETER',
  SELECT_PATH_COMPONENT: 'SELECT_PATH_COMPONENT',
  TOGGLE_PARAMETER_PANEL: 'TOGGLE_PARAMETER_PANEL',
  TOGGLE_LIBRARY_PANEL: 'TOGGLE_LIBRARY_PANEL',
  NAV_CLICKED: 'NAV_CLICKED',
}
